import React from "react";
import LoadingIcon from "../../components/Icons/Loading";
export default function NextButton({
  id,
  onClick,
  label,
  disabled = false,
  loading,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex justify-center rounded-3xl border border-transparent py-2.5 px-10 text-sm font-semibold  shadow-sm focus:outline-none focus:ring-2  focus:ring-offset-2 ${
        disabled
          ? "bg-primary-200 text-primary-300 cursor-not-allowed"
          : "focus:ring-brand-500 bg-brand-500 text-white hover:opacity-75"
      }`}
      disabled={disabled}
      {...(id ? { id } : {})} // Only adds id if it's provided
    >
      {label || "Next"}
      {loading ? (
        <div className="pl-2">
          <LoadingIcon />{" "}
        </div>
      ) : (
        ""
      )}
    </button>
  );
}
